
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconChip from '@/core/components/IconChip.vue';
import { namespace } from 'vuex-class';
import { LoanProjectionRequestQuery } from '@/loan/types/loan-projection-request-query';
import { LoanProjectionType } from '@/loan/enums/loan-projection-type';
import { LoanAPIService } from '@/loan/services/api';
import { LoanProjection } from '@/loan/types/loan-projection';
import { UtilHelper } from '@/util/helper';
import { LoanDetails as LoanDetailsInterface } from '@/loan/types/loan-details';

const loanNamespace = namespace('loan');

@Component({
	components: {
		IconChip,
	},
})
export default class SuggestedAutopay extends Vue {
	public formatDollar = UtilHelper.formatDollar;

	loading: boolean = true;

	@loanNamespace.Getter('minimumMonthlyPayment')
	public minimumMonthlyPayment!: number;

	@loanNamespace.State('loanDetails')
	public loanDetails!: LoanDetailsInterface;

	@Prop({ required: true })
	public loanId!: string;

	@loanNamespace.State('projection')
	public projection!: LoanProjection;

	interestSavedOne!: string;

	interestSavedTwo!: string;

	get calculateRoundUpValueOne(): string {
		return Math.ceil(this.minimumMonthlyPayment * 0.1).toString();
	}

	get calculateRoundUpValueTwo(): string {
		return Math.ceil(this.minimumMonthlyPayment * 0.2).toString();
	}

	async mounted() {
		const queryOne: LoanProjectionRequestQuery = {
			property: LoanProjectionType.AUTOPAY,
			value: String(Number(this.calculateRoundUpValueOne) + Number(this.minimumMonthlyPayment)),
		};

		const projectionOne = await LoanAPIService.getProjection(this.loanId, queryOne);

		this.interestSavedOne =			projectionOne.educationalInfo.avoidedInterest !== null ? projectionOne.educationalInfo.avoidedInterest : '';

		const queryTwo: LoanProjectionRequestQuery = {
			property: LoanProjectionType.AUTOPAY,
			value: String(Number(this.calculateRoundUpValueTwo) + Number(this.minimumMonthlyPayment)),
		};

		const projectionTwo = await LoanAPIService.getProjection(this.loanId, queryTwo);

		this.interestSavedTwo =			projectionTwo.educationalInfo.avoidedInterest !== null ? projectionTwo.educationalInfo.avoidedInterest : '';

		this.loading = false;
	}
}
